/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class UserRoleFilter {
    public static filter(): any {
        return (input: string): string => {
            if (!angular.isString(input)) {
                return input;
            }
            switch (input) {
                case (''): return 'Employee';
                case ('admin'): return 'HR Manager';
                case ('audit'): return 'C - Level';
                case ('edit'): return 'HR Administrator';
                default: return input;
            }
        };
    }
}


angular.module('beneple.global')
    .filter('userrole', UserRoleFilter.filter);



// WEBPACK FOOTER //
// ./frontend/scripts/global/filters/userrole.filter.ts